import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import AtlassianFormBuilder from "../../../formBuilder/AtlassianFormBuilder";
import { modifySelectedCred } from "../../../redux/actions/credActions";
import { clone } from "../../../common/utils/helper";

const REGION_SELECT_OPTIONS = [
  {
    id: "REGION",
    values: [
      { label: "Africa (Cape Town) af-south-1", value: "af-south-1" },
      { label: "Asia Pacific (Hong Kong) ap-east-1", value: "ap-east-1" },
      { label: "Asia Pacific (Hyderabad) ap-south-2", value: "ap-south-2" },
      { label: "Asia Pacific (Jakarta) ap-southeast-3", value: "ap-southeast-3" },
      { label: "Asia Pacific (Melbourne) ap-southeast-4", value: "ap-southeast-4" },
      { label: "Asia Pacific (Mumbai) ap-south-1", value: "ap-south-1" },
      { label: "Asia Pacific (Osaka) ap-northeast-3", value: "ap-northeast-3" },
      { label: "Asia Pacific (Seoul) ap-northeast-2", value: "ap-northeast-2" },
      { label: "Asia Pacific (Singapore) ap-southeast-1", value: "ap-southeast-1" },
      { label: "Asia Pacific (Sydney) ap-southeast-2", value: "ap-southeast-2" },
      { label: "Asia Pacific (Tokyo) ap-northeast-1", value: "ap-northeast-1" },
      { label: "Canada (Central) ca-central-1", value: "ca-central-1" },
      { label: "Canada (West) ca-west-1", value: "ca-west-1" },
      { label: "China (Beijing) cn-north-1", value: "cn-north-1" },
      { label: "China (Ningxia) cn-northwest-1", value: "cn-northwest-1" },
      { label: "Europe (Frankfurt) eu-central-1", value: "eu-central-1" },
      { label: "Europe (Ireland) eu-west-1", value: "eu-west-1" },
      { label: "Europe (London) eu-west-2", value: "eu-west-2" },
      { label: "Europe (Milan) eu-south-1", value: "eu-south-1" },
      { label: "Europe (Paris) eu-west-3", value: "eu-west-3" },
      { label: "Europe (Spain) eu-south-2", value: "eu-south-2" },
      { label: "Europe (Stockholm) eu-north-1", value: "eu-north-1" },
      { label: "Europe (Zurich) eu-central-2", value: "eu-central-2" },
      { label: "Israel (Tel Aviv) il-central-1", value: "il-central-1" },
      { label: "Middle East (Bahrain) me-south-1", value: "me-south-1" },
      { label: "Middle East (UAE) me-central-1", value: "me-central-1" },
      { label: "South America (Sao Paulo) sa-east-1", value: "sa-east-1" },
      { label: "US East (N. Virginia) us-east-1", value: "us-east-1" },
      { label: "US East (Ohio) us-east-2", value: "us-east-2" },
      { label: "US West (N. California) us-west-1", value: "us-west-1" },
      { label: "US West (Oregon) us-west-2", value: "us-west-2" },
      { label: "AWS GovCloud (US-East) us-gov-east-1", value: "us-gov-east-1" },
      { label: "AWS GovCloud (US-West) us-gov-west-1", value: "us-gov-west-1" },
    ],
  },
];

const AwsSignaturePage = () => {
  const dispatch = useDispatch();
  const selectedCred = useSelector((state) => state.auth.selectedCred);
  const [values, setValues] = useState([]);

  const callback = (extConfigValues) => {
    const credentials = clone(selectedCred);
    credentials.name = extConfigValues.find((v) => v.id === "NAME")?.value ?? "";

    if (!credentials.data) {
      credentials.data = {
        accessKey: "",
        secretKey: "",
        region: "",
        service: "",
        sessionToken: "",
      };
    }

    credentials.data.accessKey = extConfigValues.find((v) => v.id === "ACCESS_KEY")?.value ?? "";
    credentials.data.secretKey = extConfigValues.find((v) => v.id === "SECRET_KEY")?.value ?? "";
    credentials.data.region = extConfigValues.find((v) => v.id === "REGION")?.value ?? "";
    credentials.data.service = extConfigValues.find((v) => v.id === "SERVICE")?.value ?? "";
    credentials.data.sessionToken = extConfigValues.find((v) => v.id === "SESSION_TOKEN")?.value ?? "";

    dispatch(modifySelectedCred(credentials));
  };

  useEffect(() => {
    setValues([
      {
        id: "NAME",
        value: selectedCred.name,
      },
      {
        id: "ACCESS_KEY",
        value: selectedCred.data ? selectedCred.data.accessKey : "",
      },
      {
        id: "SECRET_KEY",
        value: selectedCred.data ? selectedCred.data.secretKey : "",
      },
      {
        id: "REGION",
        value: selectedCred.data ? selectedCred.data.region : "",
      },
      {
        id: "SERVICE",
        value: selectedCred.data ? selectedCred.data.service : "",
      },
      {
        id: "SESSION_TOKEN",
        value: selectedCred.data ? selectedCred.data.sessionToken : "",
      },
    ]);
  }, [selectedCred]);

  const fields = [
    {
      id: "NAME",
      title: "Credential name",
      type: "TEXT",
    },
    {
      id: "ACCESS_KEY",
      title: "Access key",
      type: "TEXT",
    },
    {
      id: "SECRET_KEY",
      title: "Secret key",
      type: "TEXT",
      isPassword: true,
    },
    {
      id: "REGION",
      title: "AWS region (optional)",
      type: "SELECTLIST",
      helperText: "Region that receives the request, default eu-west-1",
    },
    {
      id: "SERVICE",
      title: "Service name (optional)",
      type: "TEXT",
    },
    {
      id: "SESSION_TOKEN",
      title: "Session token (optional)",
      type: "TEXT",
      helperText: "Only required when using temp security credentials",
      isPassword: true,
    },
  ];

  return <AtlassianFormBuilder fields={fields} values={values} options={REGION_SELECT_OPTIONS} update={callback} />;
};

export default AwsSignaturePage;
